import Icon from './Icon';
import Label from './Label';

import { default as Core } from './button';

const Button = Object.assign(Core, { Icon, Label });

export default Button;
export { type Props as ButtonProps } from './button';
